import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ABOUT_ERIC_IMAGE, waLink } from "@/data/site";
import StoryIntro from "@/components/StoryIntro";

const OverEric = () => {
  return (
    <>
      <section className="pt-40 md:pt-48 pb-20 bg-white">
        <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            className="lg:col-span-6 order-2 lg:order-1"
          >
            <p className="eyebrow mb-4">Over Eric</p>
            <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl leading-[1.05]">
              De man <span className="italic text-gold">achter de camera.</span>
            </h1>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, scale: 1.05 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1.2 }}
            className="lg:col-span-6 order-1 lg:order-2"
          >
            <div className="relative aspect-[4/5] overflow-hidden bg-neutral-100">
              <img
                src={ABOUT_ERIC_IMAGE}
                alt="Eric Lemmens"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 border border-gold/40 m-4 pointer-events-none" />
            </div>
          </motion.div>
        </div>
      </section>

      <StoryIntro />

      <section className="bg-beige py-24 md:py-32">
        <div className="container-narrow max-w-3xl">
          <div className="space-y-8 text-neutral-800 leading-relaxed text-lg font-light">
            <p className="font-serif text-3xl md:text-4xl italic leading-snug text-ink">
              “Beelden die raken, verrassen en uitnodigen om niet alleen te kijken, maar ook te voelen.”
            </p>
            <p>
              Ik ben <strong className="font-medium">Eric Lemmens</strong> — Lenslopers. Autodidact
              fotograaf. Mijn werk balanceert tussen journalistieke fotografie, experiment en
              emotie, met een focus op karakter, sfeer en authenticiteit.
            </p>
            <p>
              Gedreven door nieuwsgierigheid speel ik met licht, compositie en perspectief. Ik zoek
              naar dat ene beeld waar techniek verdwijnt en gevoel overblijft. Een blik. Een
              beweging. Een schaduw. Een adempauze in een drukke dag.
            </p>
            <p>
              Ik geloof niet in fotografie die alles vooraf bepaalt. Ik geloof in aanwezig zijn,
              kijken, tijd nemen en ruimte laten voor wat vanzelf ontstaat. Soms is een moment
              perfect zonder dat iemand het doorheeft. Soms is een kleine aanwijzing genoeg om
              iemand helemaal zichzelf te laten zijn.
            </p>
            <p>Daar ontstaan de beelden die voor mij het meest waardevol zijn.</p>
            <p>
              Elke fotoshoot is voor mij een experiment. Geen twee mensen zijn hetzelfde. Geen twee
              lichtvallen zijn identiek. Geen enkel moment komt ooit precies terug. Precies daar —
              in dat spel tussen intuïtie, licht en verrassing — vind ik mijn beeld.
            </p>
            <p>
              Of het nu gaat om een portret, een huwelijk, een communie, een evenement, een huisdier
              of een bijzonder moment: ik wil niet alleen registreren wat er gebeurt. Ik wil
              vastleggen wat je voelt.
            </p>
            <p>
              Ik zoek niet naar perfectie. Ik zoek naar karakter. Naar echtheid. Naar beelden waarin
              je jezelf, je familie, je dier of het moment écht herkent.
            </p>
            <p>
              Als je bij mij komt, kom je voor iets echts. Geen dertien-in-een-dozijn foto's, maar
              beelden met een verhaal. Foto's die vandaag mooi zijn, maar vooral waarde krijgen
              naarmate de tijd verstrijkt.
            </p>
            <p className="font-serif text-xl md:text-2xl italic leading-snug text-ink">
              Iets wat je nog steeds graag bekijkt op de dag dat je kleinkinderen erbij komen
              zitten.
            </p>
            <p className="font-script text-gold text-5xl leading-none pt-4">Eric Lemmens</p>
            <p className="text-xs uppercase tracking-[0.3em] text-neutral-500">Lenslopers</p>
          </div>

          <div className="mt-16 flex flex-wrap gap-4">
            <a
              href={waLink("Hallo Eric, ik wil je graag persoonlijk spreken.")}
              target="_blank"
              rel="noreferrer"
              className="btn-gold"
            >
              Spreek me persoonlijk
            </a>
            <Link to="/portfolio" className="btn-outline-dark">
              Bekijk mijn werk
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default OverEric;
